import React from "react";

/* The "Charts" button. Two placements, both driven by the same state:

   - variant="tab"  — a floating tab on the right edge, shown only while charts
                      are available and closed (so it never covers the open panel).
   - variant="bar"  — a topbar toggle (always rendered, disabled when there are no
                      charts, "on" while the panel is open).

   `available` should be true whenever the active chat response has a
   CHARTS TO DISPLAY section AND at least one resolved player. */
export default function ChartsButton({ variant = "tab", available = false, open = false, onToggle, label = "Charts" }) {
  const chartIcon = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8}><path d="M4 20V10M10 20V4M16 20v-7M22 20H2" /></svg>
  );

  if (variant === "bar") {
    return (
      <button
        className={`charts-bar${open ? " on" : ""}`}
        onClick={onToggle}
        disabled={!available}
        title="Player charts"
        aria-label="Toggle player charts"
      >
        {chartIcon}
        <span>{label}</span>
      </button>
    );
  }

  if (!available || open) return null;
  return (
    <button className="charts-tab" onClick={onToggle} title="Show player charts">
      {chartIcon}
      {label}
    </button>
  );
}
